import type { AxiosError } from 'axios'
import type { RCustomMcpRegistrationError } from 'v2/types/api/settings'

export const getCustomMcpRegistrationError = (error: unknown) => {
  const response = (
    error as AxiosError<RCustomMcpRegistrationError & { data?: RCustomMcpRegistrationError }> | null
  )?.response
  return { status: response?.status, body: response?.data?.data ?? response?.data }
}
